const project = {
  id: 0,
  projectName: null,
  clientId: null,
  clientName: null,
  statusId: 1,
  status: null,
  createAt: null,
  createdBy: null,
  updatedAt: null,
  updatedBy: null,
  internalProject: false,
  anticipatedRevenue: null,
  projectAssignments: []
}

export default () => ({
  ...project,
  projectAssignments: []
})
